// ------------------------------------------------------------
// 画像にtokenを付与するための設定
// img(v-src="item.image_url")
// img(v-src="'http://localhost:8765/files/bimage/1'")
// ------------------------------------------------------------
import RepositoryFactory from '../repositories/RepositoryFactory'

export default function (Vue) {
  Vue.directive('src', function (el, binding, vnode) {
    const vm = vnode.context
    // 画像表示中にログアウト後した場合はキャンセルする
    if (!vm.$store.getState('token')) {
      return
    }
    if (binding.oldValue === undefined || binding.value !== binding.oldValue) {
      let imageUrl = binding.value

      // URLなし
      if (!imageUrl) {
        el.src = vm.app_imgsrc.no_image
        return
      }
      // サムネイルフラグ
      if (binding.arg === 'thumbnail') {
        imageUrl += '?thumbnail=1'
      }

      // URLあり
      const ImageRepository = RepositoryFactory.get('image')
      ImageRepository.get(imageUrl)
        .then(function (response) {
          const data = vm.getApiData(response).data
          el.src = data.src
          if (!el.alt && data.name) el.alt = data.name
          if (!el.title && data.name) el.title = data.name
        })
        .catch(function () {
          el.src = vm.app_imgsrc.not_found
        })
    }
  })
}



// WEBPACK FOOTER //
// ./src/plugins/VueImgSrc.js